module.exports = __webpack_public_path__ + "static/media/roll-dice-50.11716341.png";